<template>
    <el-card class="page_card" ref="card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>财务数据报表</span>
        </div>
        <el-form inline :model="selectForm" ref="selectForm">
            <!-- <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="企业名称" prop="companyId" label-width="200">
                <el-select
                    v-model="selectForm.companyId"
                    ref="add_com"
                    multiple
                    collapse-tags
                    filterable
                    remote
                    reserve-keyword
                    @change="selectChange"
                    placeholder="请选择企业名称">
                    <el-option
                        :disabled="selectForm.companyId.includes(0) && item.id != 0"
                        v-for="item in companys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="datetimerange"
                    align="right"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['08:00:00', '07:59:59']">
                </el-date-picker>
            </el-form-item>
             <el-form-item label="">
                <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
                <el-button plain @click="resetSelect()">重 置</el-button>
                <el-button plain type="success" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
            </el-form-item>
        </el-form>
        <el-table ref="table" :data="list" :max-height="tableMaxHeight" show-summary :summary-method="getSummaries">
            <!-- <el-table-column label="客户编号" width="">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.companyNo}}</span>
                </template>
            </el-table-column> -->
            <el-table-column label="客户名称" width="">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.companyName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="期初余额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.beginBalance==null?'0.00':parseNums(scope.row.beginBalance)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="预收款(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.advancePayment==null?'0.00':parseNums(scope.row.advancePayment)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="销量(吨)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.salesVolume==null?'0.00':parseNums(scope.row.salesVolume)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="销售金额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.salesAmount==null?'0.00':parseNums(scope.row.salesAmount)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="期末余额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.endBalance==null?'0.00':parseNums(scope.row.endBalance)}}</span>
                </template>
            </el-table-column>
        </el-table>
    </el-card>
</template>
<script>
import request from '@/utils/request'
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'
export default {
    name:'summary_table',
    data(){
        return{
            is_ok:false,
            companys:[],
            selectForm:{
                companyId:[],
                timeRange:[]
            },
            tableMaxHeight:0,
            total:0,
            list:[],
            baseUrl:'',
            listData:{}
        }
    },
    
    methods:{
        resetSelect(){
            this.selectForm = {
                companyId:[]
            };
            this.$refs["selectForm"].resetFields();
            this.getDefaultTime();
            this.getData();
        },
        getDefaultTime(){
            let dd=new Date();
            let y=dd.getFullYear();
            let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
            let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
            let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 08:00:00`
            let endTime=`${this.getNextDate(y+'-'+m+'-'+d,0)} 07:59:59`
            this.selectForm.timeRange = [startTime,endTime]
        },
        selectSubmit(){
            this.getData();
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        selectChange(v){
            if(v.includes(0)){
                this.selectForm.companyId = [0];
                this.$refs["add_com"].blur();
            }
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.companys = res.data;
                for(let item of res.data){
                    this.all_com.push(item.id);
                }
            }).catch(err=>{
            });
        },
        getData(){
            request.post("finance/company_account_statement",this.selectForm).then(res=>{
                this.listData=res.data.total;
                this.list = res.data.vos;
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-105;
            }).catch(err=>{
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-105;
            });
        },
        //分页改变
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        //保存到excel文件中
        async exportExcel(){
            try{
                let res = await fetch(this.baseUrl+"/finance/export_company_account_statement",{
                    method:"POST",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                    body:JSON.stringify(this.selectForm)
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "财务报表.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }else if(index === 1){
                    sums[index] = this.parseNums(this.listData.beginBalance);
                    return;
                }else if(index === 2){
                    sums[index] = this.parseNums(this.listData.advancePayment);
                    return;
                }else if(index === 3){
                    sums[index] = this.parseNums(this.listData.salesVolume);
                    return;
                }else if(index === 4){
                    sums[index] = this.parseNums(this.listData.salesAmount);
                    return;
                }else if(index === 5){
                    sums[index] = this.parseNums(this.listData.endBalance);
                    return;
                }
            });
            return sums;
      },
      getNextDate(date,day){
        let dd=new Date(date);
        dd.setDate(dd.getDate()+day);
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        return y+'-'+m+'-'+d;
      }
    },
    created(){
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
    },
    mounted(){
        // let dd=new Date();
        // let y=dd.getFullYear();
        // let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        // let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        // let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 08:00:00`
        // let endTime=`${this.getNextDate(y+'-'+m+'-'+d,0)} 07:59:59`
        // this.selectForm.timeRange.push(startTime,endTime)
        this.getDefaultTime();
        this.getData();
        this.getCompany();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    }
}
</script>
<style lang="scss">
    .el-tag.el-tag--info{
        display: inline-block !important;
        // width: 100% !important;
        word-wrap: break-word !important;
        height: auto !important;
        white-space: normal !important;
    }
</style>
